import React from "react";

const Award = ({ item }) => {
  return (
    <article
      className="awardContainer"
      itemScope
      itemType="https://schema.org/Award"
    >
      <img
        src={item.iconSrc}
        alt={item.desc}
        loading="lazy"
        itemProp="image"
      />

      <p itemProp="description">{item.desc}</p>
    </article>
  );
};

export default Award;
